import * as React from 'react';
import styled from 'styled-components';
import { Button } from './Button';
import { Icon } from './Icon';

interface IProps {
  attemptFix: () => void;
  message: string;
}
export const InvalidSettings = (props: IProps): React.ReactElement => {
  return (
    <Container>
      <Icon name='warning' size='medium' />
      <Message>{props.message}</Message>
      <Button
        onClick={props.attemptFix}
        style={{ marginTop: '10px' }}
        title='Fix Settings'
       />
      <SupportLink />
    </Container>
  );
};
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
`;
const Message = styled.div`
  margin-top: 20px;
  max-width: 200px;
  text-align: center;
  font-size: 1.5em;
`;

const SupportLink = (): React.ReactElement => {
  return (
    <div style={{ maxWidth: '300px', marginTop: '10px', textAlign: 'center' }}>
      If this problem persists please contact techsupport@hawkindynamics.com or
      use our support chat at &nbsp;
      <a href='https://www.hawkindynamics.com/'>www.hawkindynamics.com</a>
    </div>
  );
};
